export type CountryAvatarSize = 'sm' | 'md' | 'lg'

const SIZE_PX: Record<CountryAvatarSize, number> = {
  sm: 40,
  md: 50,
  lg: 74,
}

export function getCountryAvatarSizePx(size: CountryAvatarSize = 'md'): number {
  return SIZE_PX[size]
}

/** Two-letter initials from a country or game name. */
export function getCountryInitials(value?: string | null, fallback = '?'): string {
  const source = (value || fallback).trim()
  if (!source) return fallback.slice(0, 2).toUpperCase()

  const words = source.split(/\s+/).filter(Boolean)
  if (words.length >= 2) {
    return `${words[0][0]}${words[1][0]}`.toUpperCase()
  }

  const word = words[0]
  if (word.length >= 2) {
    return word.slice(0, 2).toUpperCase()
  }

  return word[0].toUpperCase()
}

/** Stable HSL background from country name. */
export function getCountryAvatarColor(value?: string | null): string {
  const source = (value || 'default').trim().toLowerCase()
  let hash = 0
  for (let i = 0; i < source.length; i += 1) {
    hash = source.charCodeAt(i) + ((hash << 5) - hash)
  }
  const hue = Math.abs(hash) % 360
  return `hsl(${hue}, 42%, 40%)`
}
